import type { Crop } from './salesContent';

export const volumes = [
  {
    tag: '01 — Enseñar',
    title: 'Fundamentos y Método del Instructor',
    headline: 'Aprendé a enseñar, no solamente a explicar.',
    list: ['Seguridad y bioseguridad', 'Didáctica para adultos', 'Demostración de maniobras', 'Corrección y feedback'],
    flow: ['Enseñar', 'Demostrar', 'Practicar', 'Corregir'],
    crop: { x: 60, y: 180, w: 350, h: 450 } as Crop,
  },
  {
    tag: '02 — Entrenar',
    title: 'Protocolos, Maniobras y Habilidades Críticas',
    headline: 'Qué enseñar frente a las principales emergencias.',
    list: ['RCP y DEA', 'Atragantamiento y hemorragias', 'Traumatismos y fracturas', 'Emergencias médicas y pediátricas'],
    flow: ['Reconocer', 'Decidir', 'Actuar', 'Reevaluar'],
    crop: { x: 950, y: 90, w: 345, h: 385 } as Crop,
  },
  {
    tag: '03 — Evaluar',
    title: 'Entrenamiento, Simulación y Evaluación',
    headline: 'Pasá de enseñar una maniobra a comprobar una competencia.',
    list: ['Práctica progresiva', 'Diseño de simulaciones', 'Errores críticos y debriefing', 'Evaluación práctica'],
    flow: ['Practicar', 'Simular', 'Evaluar', 'Corregir'],
    crop: { x: 950, y: 465, w: 360, h: 385 } as Crop,
  },
];